import {getCurrency, getTaxConfig} from '@wix/wix-events-commons-statics'
import {connect} from '../../runtime-context/context'
import {getOrderedTickets} from '../../../selectors/placed-order'
import {DetailsPageAppProps} from '../../app/interfaces'
import {getTickets} from '../../../selectors/tickets'
import {TicketsSummaryOwnProps, TicketsSummaryRuntimeProps} from './interfaces'
import {TicketsSummary as Presentation} from './tickets-summary'

const mapRuntime = ({state}: DetailsPageAppProps): TicketsSummaryRuntimeProps => {
  const {event, seating} = state
  const tickets = getTickets(state)

  const orderedTickets = getOrderedTickets(state, tickets)
  const taxConfig = getTaxConfig(event)

  return {
    tickets: orderedTickets,
    currency: getCurrency(event),
    taxConfig,
    seatingPlan: seating.plan,
  }
}

export const TicketsSummary = connect<TicketsSummaryOwnProps, TicketsSummaryRuntimeProps>(mapRuntime)(Presentation)

export * from './interfaces'
